import { useAuthActions } from "@convex-dev/auth/react";
import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api.js";

// Type for the authenticated user returned from getCurrentUser query
export interface AuthUser {
  id: string;
  email: string;
  name: string;
  isAdmin: boolean;
  createdAt: number;
}

export function useAuth() {
  const { signIn, signOut } = useAuthActions();
  const user = useQuery(api.users.getCurrentUser);

  const login = async (email: string, password: string) => {
    try {
      await signIn("password", { email, password, flow: "signIn" });
    } catch (error: unknown) {
      // Check for specific error types
      const errorMessage = error instanceof Error ? error.message : String(error);
      if (errorMessage?.includes("Invalid credentials")) {
        throw new Error("Incorrect email or password. Please check your credentials and try again.");
      }
      if (errorMessage?.includes("User not found")) {
        throw new Error("No account found with this email. Please check your email or contact your administrator.");
      }
      // Generic fallback
      throw new Error("Unable to sign in. Please check your email and password.");
    }
  };

  const logout = async () => {
    await signOut();
  };

  return {
    user: user as AuthUser | null,
    login,
    logout,
    isAuthenticated: !!user,
    isLoading: user === undefined,
  };
}